var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 15h12a1 1 0 1 1 0 2H17v12a1 1 0 1 1-2 0V17H3a1 1 0 1 1 0-2h12V3a1 1 0 1 1 2 0z"
})));
export default SvgPlus;